import { curry, get, isUndefined, isNull } from 'lodash-es';
import { isPreProd, isUsed } from 'site-modules/shared/utils/publication-states';
import { DEALERLESS_OEM } from 'site-modules/shared/constants/oem';
import { isEditorialRatingPathExists } from 'site-modules/personalized-search/utils/check-paths-existence';

const checkHeaderData = ({
  vehicle,
  photoUrl,
  msrpPriceRanges,
  editorialRating,
  usedTmv,
  usedBaseStyle,
  submodelAmounts,
}) => {
  if (!vehicle) {
    return false;
  }

  function checkUsedTmvPropPresent() {
    if (isUndefined(usedBaseStyle) || isUndefined(submodelAmounts)) {
      return false;
    }

    if (isNull(usedBaseStyle) || isNull(submodelAmounts)) {
      return true;
    }

    return !!get(submodelAmounts, `priceRanges["${vehicle.submodels?.slug}"]`) || !isUndefined(usedTmv);
  }

  if (isUsed(vehicle.pubStates)) {
    return (
      !isUndefined(photoUrl) &&
      (!isUndefined(editorialRating) || !isEditorialRatingPathExists(vehicle)) &&
      checkUsedTmvPropPresent()
    );
  }

  const isMsrpPriceRanges = !isPreProd(vehicle.pubStates) ? !isUndefined(msrpPriceRanges) : true;

  return !isUndefined(photoUrl) && !isUndefined(editorialRating) && isMsrpPriceRanges;
};

const checkHighlightsData = ({ vehicle, trimSummary, style }) =>
  !!vehicle && !isUndefined(trimSummary) && (!trimSummary?.styleId || !!style);

const checkOpinionData = ({ vehicle, editorialTrims, trimSummary }) =>
  !!vehicle && (!isUndefined(editorialTrims) || trimSummary === null);

const checkCtaData = ({ vehicle, trimSummary, leadFormDealerCount }) => {
  if (!vehicle) {
    return false;
  }

  if (isUsed(vehicle.pubStates)) {
    return true;
  }

  const isLeadFormDealerCount = isPreProd(vehicle.pubStates) ? !isUndefined(leadFormDealerCount) : true;
  const isTrimSummary =
    !isPreProd(vehicle.pubStates) && !DEALERLESS_OEM.includes(vehicle.make.slug) ? !isUndefined(trimSummary) : true;
  return isTrimSummary && isLeadFormDealerCount;
};

const checkInventoryData = ({ inventoryData }) => !isUndefined(inventoryData);
const checkOverviewItemData = ({ vehicle }) => !isUndefined(vehicle);

const checkedFunctions = {
  header: checkHeaderData,
  highlights: checkHighlightsData,
  cta: checkCtaData,
  opinion: checkOpinionData,
  inventory: checkInventoryData,
  overviewItem: checkOverviewItemData,
};

export const checkLoadedData = curry((componentName, data) => {
  const checkedFunction = checkedFunctions[componentName];
  return checkedFunction(data);
});
